import { Attribute, ChangeDetectionStrategy, Component, ElementRef } from "@angular/core";

@Component({
    selector: 'cs-label',
    templateUrl: 'cs-label.html',
    host: { 'class': 'label' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsLabelComponent {

    constructor(
        @Attribute('stacked') public stacked: boolean,
        public elementRef: ElementRef) { }
}